import React, { ReactNode } from "react";
import SearchIcon from "../assets/icons/searchIcon";

import "./searchBarWithDropdown.css";
import Dropdown from "./dropdown";
import { PieceFilterDTOOrderOptionEnum } from "../openapi-generated-client";
import { formatEnumValue } from "../utils/objectUtils";
import useWindowDimensions from "../utils/useWindowDimensions";
import SearchBar from "./searchBar";

interface SearchBarWithDropdownProps {
    children?: ReactNode;
    dropdown: {
        prefix: string;
        options: string[];
        selectedOption: number;
        setSelectedOption: (id: number) => void;
    }
    search: string;
    setSearch: (search: string) => void;
    headerPart?: ReactNode;
}

export default function SearchBarWithDropdown(props: SearchBarWithDropdownProps) {

    const windowDimensions = useWindowDimensions();

    if(windowDimensions.width < 1050) {
        return <>
            <SearchBar search={props.search} onSearch={(search) => props.setSearch(search)}/>
            {props.children}
            <div className="mobile-header-part">
                {props.headerPart}
                <Dropdown prefix={props.dropdown.prefix} options={props.dropdown.options} selectedOption={props.dropdown.selectedOption} setSelectedOption={props.dropdown.setSelectedOption}/>
            </div>
        </>
    }

    return <>
        <div className="search-bar-with-dropdown">
            <SearchIcon/>
            <input placeholder="Search" type="text" value={props.search} onChange={(e) => props.setSearch(e.target.value)}/>
            <hr/>
            <Dropdown prefix={props.dropdown.prefix} options={props.dropdown.options} selectedOption={props.dropdown.selectedOption} setSelectedOption={props.dropdown.setSelectedOption}/>
        </div>
        {props.children}
    </>;

}